<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty>

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay tipos de documento que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha agregado ningún tipo de documento
                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';

export default {
    name: 'SettingListTypeDocument',

    components: {
        AlertDismiss
    },

    async mounted(){
        await this.getAllTypes();

        this.$eventBus.$on(EventNames.CreatedDocumentType, async () => {
            this.cargandoTabla();
            await this.getAllTypes();
            this.cargandoTabla();
        });
    },

    data() {
        return {
            isBusy: false,

            fields: [
                { key: 'nombre', label: 'Nombre del tipo de documento' },

                {
                    key: 'creacionFormat',
                    label: 'Fecha creación',
                    formatter: (value) => {
                        return value;
                    }
                },
            ],

            selected: [],

            items: []
        }
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            // Filtrar data

            return filtered;
        }
    },

    methods:{
        ...mapActions(["allDocumentType"]),

        onRowSelected(items) {
            this.selected = items;
        },

        cargandoTabla(){
            this.isBusy = ! this.isBusy;
        },

        async getAllTypes(){
            this.cargandoTabla();
            let result = await this.allDocumentType();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.cargandoTabla();
                return;
            }

            let data = result.data.map((type) => {
                return {
                    nombre: type.name,
                    creacionFormat: this.formatDate(type.creationDate) ?? '',
                }
            });

            this.items = data;
            this.cargandoTabla();
        },

        formatDate(date) {
            if (date == null) {
                return;
            }

            // Crear un objeto Date con la fecha y hora ISO
            var fechaHora = new Date(date);

            // Formatear la fecha y hora en un formato legible para el usuario
            var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fechaHora.toLocaleDateString('es-ES', opcionesFormato);
        },
    }
    
}
</script>
<style>
    
</style>